exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-button[data-v-3560bf15] {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n}\n.alert-z[data-v-3560bf15] {\n  z-index: 0 !important;\n}\n", ""]);

// exports
